import { FC } from 'react';
import Image from '@components/Image';
import { IconLock } from '@tabler/icons-react';

interface PoweredByFooterProps {
  isHidden?: boolean;
  className?: string;
  textSecurePayment?: boolean;
}

const PoweredByFooter: FC<PoweredByFooterProps> = ({
  isHidden = false,
  className = 'mx-auto pt-4 hidden max-w-fit lg:block',
  textSecurePayment = true,
}) => {
  if (isHidden) return null;

  return (
    <div className={className}>
      <div className="flex flex-col items-center gap-3">
        {textSecurePayment && (
          <div className="flex flex-row items-center gap-2 text-sm text-gray-500">
            <IconLock size={16} />
            <span>
              Your payment will be securely processed through Doitpay.
            </span>
          </div>
        )}
        <div className="flex flex-row items-center gap-2">
          <span className="text-[10px]">Powered by</span>
          <Image
            className="h-[20px] w-[45px] object-contain"
            src={'/images/logos/logo.png'}
            alt="Business Logo"
          />
        </div>
      </div>
    </div>
  );
};

export default PoweredByFooter;
